import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Row, Col } from 'reactstrap';
import Swiper from 'react-id-swiper';
import _ from 'lodash';

import * as vars from '../../constants/constants';
import { messages } from '../../constants/messages';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { addVideoHistory, addChannelHistory } from '../../actions/HistoryActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { Videos360 } from '../../constants/videos';
import { getDetails, getInterests } from '../../actions/AccountActions';
import { console_log } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import { FormattedMessage } from 'react-intl';
import { sendData } from '../../analytics/sendData';
import ShowPopup from '../ShowPopup/ShowPopup';


const restrictedCategories = {
    pt: [1]
}

class Category extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.scroll = (ref) => {
            ref.current.scrollIntoView({ behavior: 'smooth' })
        }
        this.state = {
            type: '',
            bannerno: 0,
            switchToFavourite: false,
            bannerDetailsTV: [
                { text: '', image: './img/space360.jpg', shortText: 'Mobio360 Videos' }
            ],
            bannerDetailsVOD: [
                { text: 'Explore a new world<br>experience today!', image: './img/slider/slide-one.jpg', shortText: 'Mobio360 Photos' },
            ],
            allVids: [],
            shuffleCount: 0,
            showSubscriptionScreen: false, // Screen 2 subscription plans dikhane ke liye
            selectedPlan: null // User ne kaunsa plan select kiya
        };
        this.swiper = null;
        this.interval = null;
        this.goToPlay = this.goToPlay.bind(this);
        this.goToPlayOthers = this.goToPlayOthers.bind(this);
        this.channelFavorite = this.channelFavorite.bind(this);
        this.isChannelFavorite = this.isChannelFavorite.bind(this);
        this.videoFavorite = this.videoFavorite.bind(this);
        this.isVideoFavorite = this.isVideoFavorite.bind(this);
        this.showFavorite = this.showFavorite.bind(this);
        this.switchBannerImage = this.switchBannerImage.bind(this);
        this.shuffle = this.shuffle.bind(this);
        this.onClickWhatsappIcon = this.onClickWhatsappIcon.bind(this);
        this.goToDownloadapks = this.goToDownloadapks.bind(this);
        this.handleDaftarMasukClick = this.handleDaftarMasukClick.bind(this);
        this.handlePlanSelect = this.handlePlanSelect.bind(this);
        this.handleTelkomselPayment = this.handleTelkomselPayment.bind(this);
        this.handleLanjutClick = this.handleLanjutClick.bind(this);
    }

    componentWillMount() {
        this.setState({
            allVids: this.filterVideos(Videos360)
        })
        if (this.props.history.location.pathname.split('/')[2] == 'vod') {
            this.setState({
                type: 'vod'
            });
            this.props.setHeaderTitle("VOD Channels");
        } else {
            this.props.history.goBack();
        }
        if (this.props.access.token != '') {
            axios.defaults.headers.common['authorization'] = this.props.access.token;
        }

    }

    componentDidMount() {
        sendData('', '', 'video', 'viewed');
        this.interval = setInterval(() => {
            if (this.swiper != null) {
                this.swiper.slideNext();
            }
        }, 40000);
        this.props.setHeaderTitle('');
        document.body.classList.add("category");
        if (config.domain != 'pt') {
            this.props.show();
            setTimeout(() => {
                this.props.hide();
            }, 1500);
        }
        if (this.props.account.interests.length <= 0) {
            // this.props.show();

            axios.all([axios.get(vars.BASE_API_URL + '/interests'), axios.get(vars.BASE_API_URL + '/favorites'), axios.get(vars.BASE_API_URL + '/history'), axios.get(vars.BASE_API_URL + '/likes')])
                .then(axios.spread((interests, favorites, history, likes) => {


                    // for interests
                    if (interests.data.data) {
                        this.props.getInterests(interests.data.data);
                    }

                    // for favorites
                    if (favorites.data.data) {
                        this.props.addFavoriteChannel(favorites.data.data.channels);
                        this.props.addFavoriteVideo(favorites.data.data.videos);
                    }

                    // for history
                    if (history.data.data) {
                        this.props.addChannelHistory(history.data.data.channels);
                        this.props.addVideoHistory(history.data.data.videos);
                    }

                    // for likes
                    if (likes.data.data) {
                        this.props.addLikesChannels(likes.data.data.channels);
                        this.props.addLikesVideos(likes.data.data.videos);
                    }
                }))
                .then(() => {
                    axios.get(vars.BASE_API_URL + '/getUserProfile')
                        .then(userProfile => {
                            if (userProfile.data.data) {
                                this.props.getDetails(userProfile.data.data);
                            }
                        })
                        .catch(err => {
                            console.log('error in fetching user profile ----------', err);
                        })
                })
                .catch(err => {
                    console_log(err);
                });
        } else {
            this.props.getDetails(this.props.account.user);
            this.props.getInterests(this.props.account.interests);
            this.props.addFavoriteChannel(this.props.favorite.channels);
            this.props.addFavoriteVideo(this.props.favorite.videos);
            this.props.addLikesChannels(this.props.favorite.channelsLiked);
            this.props.addLikesVideos(this.props.favorite.videosLiked);
            this.props.addChannelHistory(this.props.historyVideos.channels);
            this.props.addVideoHistory(this.props.historyVideos.videos);

        }

        const needsSubscription = !(this.props.account.user && this.props.account.user.isSubscribed);
        this.setState({ showSubscriptionFlow: needsSubscription });
    }


    componentWillUnmount() {
        clearInterval(this.interval);
        document.body.classList.remove("category");
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.history.location.pathname.split('/')[2] == 'vod') {
            this.setState({
                type: 'vod'
            });
            this.props.setHeaderTitle("VR Videos");
        }
    }

    goToPlay(data, event) {
        event.preventDefault();
        const locastorage_data = sessionStorage.getItem('authorized');
        console.log(sessionStorage);
        let uid = '';
        if (locastorage_data) {
            uid = JSON.parse(locastorage_data).uid

        }
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            if (data.channel) {
                this.channelFavorite(data);
            } else {
                let videoCategory = this.props.category.videos.find((category) => {
                    return category.id == data.category;
                });
                this.videoFavorite(data.video, videoCategory.categoryName);
            }
        } else {
            sessionStorage.setItem('PlayReducer', JSON.stringify(data))
            this.props.getVideoOrChannelRelatedData(data);
            if (data.channel) {
                this.props.history.push('/play/channel/?uid=' + uid);
            } else {
                this.props.history.push(`/play/video/?vid=${data.video.id}&uid=${uid}`);
            }
        }
    }

    goToPlayOthers(data, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            let videoCategory = this.props.category.videos.find((category) => {
                return category.id == data.category;
            });
            this.videoFavorite(data.video, videoCategory.categoryName);
        } else {
            this.props.getVideoOrChannelRelatedData(data);
            this.props.history.push('/show');
        }
    }

    channelFavorite(data) {
        let favoriteChannels = this.props.favorite.channels;
        let indexOf = favoriteChannels.findIndex((f) => {
            return f.channelId == data.channel.channelId;
        });
        let channelToBeUpdated = {
            channelId: data.channel.channelId,
            channelName: data.channel.channelName,
            channelLang: data.channel.channelLang,
            channelImage: data.channel.channelImage,
            channelLogo: data.channel.channelLogo,
            channelGrade: data.channel.channelGrade,
            channelStatus: data.channel.channelStatus,
            channelBaseline: data.channel.channelBaseline,
            channelCategories: data.channel.channelCategories,
            isFavorite: true
        };

        if (indexOf == -1) {
            favoriteChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL + "/favorites/channels", channelToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteChannels.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL + "/favorites/channels/" + channelToBeUpdated.channelId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteChannel(favoriteChannels);
    }

    videoFavorite(data, category) {
        let favoriteVideos = this.props.favorite.videos;
        let indexOf = favoriteVideos.findIndex((f) => {
            return f.videoId == data.id;
        });
        let videoToBeUpdated = {
            videoId: data.id,
            duration: data.duration,
            name: data.name[(config.lang == "pt" || config.lang == "no") ? "en" : config.lang],
            preview: data.preview
        };

        if (indexOf == -1) {
            favoriteVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteVideos.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteVideo(favoriteVideos);
    }

    isChannelFavorite(channelId) {
        let indexOf = this.props.favorite.channels.findIndex((f) => {
            return f.channelId == channelId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    isVideoFavorite(videoId) {
        let indexOf = this.props.favorite.videos.findIndex((f) => {
            return f.videoId == videoId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    showFavorite() {
        this.setState({
            switchToFavourite: !this.state.switchToFavourite
        })
    }

    switchBannerImage() {
        const bulletList = document.querySelector(".custom-slider-bullets-list");
        const bulletListItem = Array.from(bulletList.children);
        const entityList = document.querySelectorAll(".custom-slider-container a-entity");
        bulletList.addEventListener("click", function (e) {
            if (e.target.tagName == "LI") {
                bulletListItem.forEach(function (item) {
                    if (item.classList.contains("active")) {
                        item.classList.remove("active");
                    }
                })
                if (!e.target.classList.contains("active")) {
                    e.target.classList.add("active");
                }
                const targetEntity = document.querySelector(e.target.dataset.target);
                entityList.forEach(function (entity) {
                    if (entity === targetEntity) {
                        entity.setAttribute("visible", "true");
                    } else {
                        entity.setAttribute("visible", "false");
                    }
                })
            }
        })
    }
    gotovod() {
        this.setState({
            switchToFavourite: !this.state.switchToFavourite

        })
    }
    shuffle(videoArray) {
        if (this.state.shuffleCount == 0) {
            let ctr = videoArray.length;
            let temp;
            let index;

            // While there are elements in the array
            while (ctr > 0) {
                // Pick a random index
                index = Math.floor(Math.random() * ctr);
                // Decrease ctr by 1
                ctr--;
                // And swap the last element with it
                temp = videoArray[ctr];
                videoArray[ctr] = videoArray[index];
                videoArray[index] = temp;
            }
            this.setState({
                shuffleCount: this.state.shuffleCount + 1
            })
        }
        return videoArray;
    }

    filterVideos(allVids) {
        const restrictedVids = [27, 65];
        const restrictedVidsMe = [27, 50, 65, 91, 92];
        const restrictedVideosEg = [26, 31]
        let vids = allVids.map(cat => {
            if (config.domain == 'me')
                return {
                    ...cat,
                    "videos": cat.videos.filter(vid => restrictedVidsMe.indexOf(vid.id) == -1)
                }
            else return {
                ...cat,
                "videos": cat.videos.filter(vid => restrictedVids.indexOf(vid.id) == -1)
            }
        })
        if (config.domain == 'pt') {
            vids = vids.filter(category => {
                return restrictedCategories[config.domain].indexOf(category.id) == -1;
            })
        }
        if (config.domain !== 'za') {
            vids = vids.filter(category => {
                return category.categoryName['en'] !== 'Romantic Valentine City Tour';
            })
        }
        if(config.domain === 'eg'){
            // get adventure cat
            let adv = vids.filter(category => {
                return category.categoryName["en"] === "Adventure"
            })[0]
            vids = vids.filter(category => {
                return category.categoryName["en"] !== "Adventure"
            })
            let allowed_vids_adv = adv.videos.filter((item) => {
                return restrictedVideosEg.indexOf(item.id) < 0
            })
            adv = {...adv, videos: allowed_vids_adv}
            vids = [...vids, adv]
        }
        // if(config.domain === "demo"){
        //     vids = vids.filter(category => {
        //         return ["Adventure", "Documentaries", "Escape Reality", "360 Library", "Amazement", "Mix VR", "3D Fun", "Entertainment", "Amazing 360", "360 World", "Tiktok Tips & Tricks"].indexOf(category.categoryName["en"]) < 0
        //     })
        // }
        return vids;
    }
    onClickWhatsappIcon() {
        sendData('', '', 'video', 'WA chat clicked', {page: 'homepage'});
        window.open('https://wa.me/12028528006?text=Hello')
    }

    goToDownloadapks({ apkurl }) {
        const a = document.createElement('a');
        a.href = apkurl;
        a.download = ''; // Browser ko force karega download mode me
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    // Screen 1: Daftar/Masuk button click handler
        handleDaftarMasukClick() {
            this.setState({ showSubscriptionScreen: true });
            sendData('', '', 'subscription', 'daftar_masuk_clicked');
        }
    
        // Screen 2: Plan selection handler
        handlePlanSelect(plan) {
            this.setState({ selectedPlan: plan });
            sendData('', '', 'subscription', 'plan_selected', { plan: plan.name });
        }
    
        // Screen 2: Telkomsel payment button handler
        handleTelkomselPayment() {
            if (!this.state.selectedPlan) {
                alert('Silakan pilih paket terlebih dahulu');
                return;
            }
            console.log('Telkomsel Payment for plan:', this.state.selectedPlan);
            sendData('', '', 'subscription', 'telkomsel_payment_clicked', { plan: this.state.selectedPlan.name });
            // Yahan aap Telkomsel payment API call kar sakte ho
        }
    
        // Screen 2: Lanjut button handler
        handleLanjutClick() {
            if (!this.state.selectedPlan) {
                alert('Silakan pilih paket terlebih dahulu');
                return;
            }
            console.log('Lanjut clicked for plan:', this.state.selectedPlan);
            sendData('', '', 'subscription', 'lanjut_clicked', { plan: this.state.selectedPlan.name });
            // Yahan aap next step ka logic implement kar sakte ho
        }
    

    render() {

        this.props.category.videos = this.state.allVids;
        //console.log("Categories", this.props.category.videos);
        const shuffledCategories = this.state.allVids.slice().sort(() => Math.random() - 0.5);
        console.log("shuffledCategories", shuffledCategories);

        const
            slides = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 10,
                speed: 500,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    575: {
                        spaceBetween: 15,
                    },
                }
            };
        let favoriteVideosIds = this.props.favorite.videos.map((v) => v.videoId);
        let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
        let Favoritevideos = this.props.category.videos.filter((m) => { if (~favoriteVideosIds.indexOf(m.id)) return m });

        // if(config.domain == 'za') {
        //     this.props.category.videos =this.props.category.videos.map(category => {
        //         if (category.categoryName.en == 'Adventure') return {
        //             ...category, id: -1, categoryName: {
        //                 ...category.categoryName, en: 'Romance Valentines City Tour'
        //             }
        //         }
        //         else return category;
        //     }).sort((cat1, cat2) => {
        //         return (cat1.id < cat2.id) ? -1 : 1; 
        //     })
        // }

        return (
            <section className="category banner-slider">

                <div className="banner-slider__wrap">
                    {(isIE) ?
                        <div className="custom-slider-container fullView">
                            <div className="responsive-banner">
                                {(window.location.hostname.includes('cine360')) ?
                                <img className="responsive-banner-image" src="./img/mobio-360-homebanner-cine360.jpg" alt="" />
                                :
                                <img className="responsive-banner-image" src="./img/mobio-360-homebanner.jpg" alt="" />
                                }
                            </div>
                            <img className="people-image" src="./img/The-Rift-New-Star-min1.png" alt="" />
                        </div>
                        :
                        <div className="custom-slider-container fullView">
                             {this.props.location.state && this.props.location.state.isVisible?
                             <ShowPopup/>:
                             null}
                            <div className="responsive-banner">
                                {(window.location.hostname.includes('cine360')) ?
                                <img className="responsive-banner-image" src="./img/mobio-360-homebanner-cine360.jpg" alt="" />
                                :
                                <img className="responsive-banner-image" src="./img/mobio-360-homebanner.jpg" alt="" />
                                }
                            </div>
                            <h3 className="banner-text-right">
                                <FormattedMessage id="homeCatBannerText"
                                    defaultMessage="EXPERIENCE THE EXTRAORDINARY"
                                />
                            </h3>
                        </div>
                    }
                </div>


                <div className="star-banner"></div>

                <div className="category-head" id="on-top-star">
                    <h3 className="on-top-star-h3">
                        {(!this.state.switchToFavourite) ?
                            <FormattedMessage id="allCategories"
                                defaultMessage="All Categories"
                            />
                            :
                            <FormattedMessage id="allFavorites"
                                defaultMessage="All Favorites"
                            />
                        }
                    </h3>
                    <div className="category-head__favorite">
                        <h3 className="on-top-star-h3" style={config.dir=='rtl'?{paddingLeft: 20 +'px'}:{}}>
                            <FormattedMessage id="favorites"
                                defaultMessage="Favorites"
                            />
                        </h3>
                        <label className="switch">
                            <input type="checkbox" className="switch__checkbox" checked={this.state.switchToFavourite} onChange={this.showFavorite} />
                            <span className="switch__slider round"></span>
                        </label>
                    </div>
                </div>

                
                {!this.state.switchToFavourite && this.props.category.videos && window.location.hostname.includes('cine360') && config.domain =='id' ?
                    shuffledCategories.map((videos, key) => {
                        return (
                            <div key={key} className="category-slider shuffled">
                                <Row>
                                    <Col>
                                        <div className="d-flex justify-content-between channel-head">
                                            <h3 className="channel-title">{videos.categoryName[config.lang] || videos.categoryName.en}</h3>
                                        </div>
                                        {videos.videos ?
                                            <Swiper {...slides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                {this.shuffle(videos.videos).map((v, k) => {
                                                    return (
                                                        <div key={v.id} className="channels-thumb" onClick={this.goToPlay.bind(this, { video: v, category: videos.id })}>
                                                            <div className="channels-image">
                                                                <img className="channels-thumb__image" src={v.preview} alt={v.name[(config.lang === 'pt' || config.lang === 'no' || config.lang === 'de') ? 'en' : config.lang]} />
                                                                <div className="channels-thumb__details">
                                                                    <div className="channels-thumb__fav">
                                                                        <input className="icon-toggle favoriteClick" id={'vod-' + v.id} type="checkbox" checked={this.isVideoFavorite(v.id)} onChange={() => { console_log("favorite Changed") }} />
                                                                        <label className="icon-toggle-label favoriteClick" htmlFor={'vod-' + v.id}>
                                                                            <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="channels-thumb__inner">
                                                                        <div className="channels-thumb__name">
                                                                            {v.name[config.lang] ? v.name[config.lang] : v.name['en']}
                                                                        </div>
                                                                        <div className="channels-thumb__extra">
                                                                            {/* <span className="channels-thumb__time">{moment.utc(v.duration*1000).format('HH:mm:ss')}</span> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Swiper>
                                            : ''}
                                    </Col>
                                </Row>
                            </div>
                        )
                    })
                    :
                    !this.state.switchToFavourite && this.props.category.videos ?
                    this.props.category.videos.sort((a, b) => a.id > b.id).map((videos, key) => {
                        return (
                            <div key={key} className="category-slider nonshuffled">
                                <Row>
                                    <Col>
                                        <div className="d-flex justify-content-between channel-head">
                                            <h3 className="channel-title">{videos.categoryName[config.lang] || videos.categoryName.en}</h3>
                                        </div>
                                        {videos.videos ?
                                            <Swiper {...slides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                {this.shuffle(videos.videos).map((v, k) => {
                                                    return (
                                                        <div key={v.id} className="channels-thumb" onClick={this.goToPlay.bind(this, { video: v, category: videos.id })}>
                                                            <div className="channels-image">
                                                                <img className="channels-thumb__image" src={v.preview} alt={v.name[(config.lang === 'pt' || config.lang === 'no' || config.lang === 'de') ? 'en' : config.lang]} />
                                                                <div className="channels-thumb__details">
                                                                    <div className="channels-thumb__fav">
                                                                        <input className="icon-toggle favoriteClick" id={'vod-' + v.id} type="checkbox" checked={this.isVideoFavorite(v.id)} onChange={() => { console_log("favorite Changed") }} />
                                                                        <label className="icon-toggle-label favoriteClick" htmlFor={'vod-' + v.id}>
                                                                            <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="channels-thumb__inner">
                                                                        <div className="channels-thumb__name">
                                                                            {v.name[config.lang] ? v.name[config.lang] : v.name['en']}
                                                                        </div>
                                                                        <div className="channels-thumb__extra">
                                                                            {/* <span className="channels-thumb__time">{moment.utc(v.duration*1000).format('HH:mm:ss')}</span> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Swiper>
                                            : ''}
                                    </Col>
                                </Row>
                            </div>
                        )
                    })
                    :
                    this.props.category.videos.sort((a, b) => a.id > b.id).map((videos, key) => {
                        let packageVideos = videos.videos.filter((video) => {
                            if (~favoriteVideosIds.indexOf(video.id)) {
                                return video;
                            }
                        });
                        if (packageVideos.length > 0) {
                            return (
                                <div key={key} className="category-slider">
                                    <Row>
                                        <Col>
                                            <div className="d-flex justify-content-between channel-head">
                                                <h3 className="channel-title">{videos.categoryName[config.lang] || videos.categoryName.en}</h3>
                                                {/* <a className="channel-browse" href={"/#/videos/"+videos.id}>
                                                    <span className="grid-icon" dangerouslySetInnerHTML={{ __html: gridIcon }} />
                                                    View All
                                                </a> */}
                                            </div>
                                            {packageVideos ?
                                                <Swiper {...slides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                    {packageVideos.map((v, k) => {
                                                        return (
                                                            <div key={v.id} className="channels-thumb" onClick={this.goToPlay.bind(this, { video: v, category: videos.id })}>
                                                                <div className="channels-image">
                                                                    <img className="channels-thumb__image" src={v.preview} alt={v.name[(config.lang == "pt" || config.lang == "no" || config.lang == "de") ? 'en' : config.lang]} />
                                                                    <div className="channels-thumb__details">
                                                                        <div className="channels-thumb__fav">
                                                                            <input className="icon-toggle favoriteClick" id={'vod-' + v.id} type="checkbox" checked={this.isVideoFavorite(v.id)} onChange={() => { console_log("favorite Changed") }} />
                                                                            <label className="icon-toggle-label favoriteClick" htmlFor={'vod-' + v.id}>
                                                                                <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="channels-thumb__inner">
                                                                            <div className="channels-thumb__name">
                                                                                {v.name[config.lang] ? v.name[config.lang] : v.name['en']}
                                                                            </div>
                                                                            <div className="channels-thumb__extra">
                                                                                { /*  <span className="channels-thumb__time">{moment.utc(v.duration*1000).format('HH:mm:ss')}</span>
                                                                                */ }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </Swiper>
                                                : ''}
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    })
                }
                {config.domain =='ch' || config.domain =='fr' ?
                    <div className="category-slider">
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-between channel-head">
                                    <h3 className="channel-title">Utilities</h3>
                                </div>
                                <div className="swiper-container swiper-container-initialized swiper-container-horizontal">
                                    <div className="swiper-wrapper" style={{transform: 'translate3d(0, 0, 0)'}}>
                                        <div className="swiper-slide channels-thumb swiper-slide-active" style={{marginRight: '10px'}} onClick={this.goToDownloadapks.bind(this, { apkurl: 'https://cdn.mobio360.com/Utilities/mergemultiplepdf.apk' })}>
                                            <div className="channels-image">
                                                <img className="channels-thumb__image" src="https://cdn.mobio360.com/Utilities/mergemultiplepdf.png" alt="PDF Merger" />
                                                <div className="channels-thumb__details">
                                                    <div className="channels-thumb__fav">
                                                        <input className="icon-toggle favoriteClick" id="vod-2040" type="checkbox" />
                                                        <label className="icon-toggle-label favoriteClick" htmlFor="vod-2040">
                                                            <span className="favoriteClick">
                                                                <i className="fa fa-star favoriteClick" aria-hidden="true"></i>
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="channels-thumb__inner">
                                                        <div className="channels-thumb__name">PDF Merger</div>
                                                        <div className="channels-thumb__extra"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="swiper-slide channels-thumb swiper-slide-next" style={{marginRight: '10px'}} onClick={this.goToDownloadapks.bind(this, { apkurl: 'https://cdn.mobio360.com/Utilities/qrscanner.apk' })}>
                                            <div className="channels-image">
                                                <img className="channels-thumb__image" src="https://cdn.mobio360.com/Utilities/qrscanner.png" alt="QR Scanner" />
                                                <div className="channels-thumb__details">
                                                    <div className="channels-thumb__fav">
                                                        <input className="icon-toggle favoriteClick" id="vod-2050" type="checkbox" />
                                                        <label className="icon-toggle-label favoriteClick" htmlFor="vod-2050">
                                                            <span className="favoriteClick">
                                                                <i className="fa fa-star favoriteClick" aria-hidden="true"></i>
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="channels-thumb__inner">
                                                        <div className="channels-thumb__name">QR Scanner</div>
                                                        <div className="channels-thumb__extra"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-button-next swiper-button-disabled" tabIndex="0" role="button" aria-label="Next slide" aria-disabled="true"></div>
                                    <div className="swiper-button-prev swiper-button-disabled" tabIndex="0" role="button" aria-label="Previous slide" aria-disabled="true"></div>
                                    <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""
                }
                {this.state.type == 'vod' && this.state.switchToFavourite && Favoritevideos.length <= 0 ?
                    <div className="no-favorite-category">
                        <div className="no-favorites__pane">
                            <h4 className="favorites__pane__title">
                                <FormattedMessage id="noVideos"
                                    defaultMessage="No Videos Added To Watch Later Yet"
                                />
                            </h4>
                            <p className="favorites__pane__text">
                                <FormattedMessage id="addYourFav"
                                    defaultMessage="Add your favorite videos to access and watch easily without any hassles"
                                />
                            </p>
                        </div>
                        <div className="text-center">
                            <a className="common-btn common-btn--pink common-btn--fav" onClick={() => this.gotovod()}>
                                <span className="common-btn__text text-white">
                                    <FormattedMessage id="explore"
                                        defaultMessage="Explore VR Videos"
                                    />
                                </span>
                            </a>
                        </div>
                    </div>
                    : ""
                }
                {/* Screen 1 & 2: Subscription Flow for Indonesia Cine360 */}
                                                {window.location.hostname.includes('cine360') && config.domain == 'id' && (
                                                    <React.Fragment>
                                                        {!this.state.showSubscriptionScreen ? (
                                                            /* Screen 1: Sirf Daftar/Masuk button */
                                                            <div className="sticky-bottom-container">
                                                                <button 
                                                                    className="daftar-masuk-btn" 
                                                                    onClick={this.handleDaftarMasukClick}
                                                                >
                                                                    <span className="btn-text">Masuk / Daftar</span>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            /* Screen 2: Subscription Plans */
                                                            <div className="subscription-screen-overlay">
                                                                <div className="subscription-screen-container">
                                                                    <div className="subscription-header">
                                                                        <button 
                                                                            className="back-button"
                                                                            onClick={() => this.setState({ showSubscriptionScreen: false, selectedPlan: null })}
                                                                        >
                                                                            <i className="fa fa-arrow-left"></i>
                                                                        </button>
                                                                        <h2 className="subscription-title">Pilih Paket Langganan</h2>
                                                                    </div>
                
                                                                    <div className="subscription-plans">
                                                                        {/* Plan 1: 3 Days */}
                                                                        <div 
                                                                            className={'subscription-plan-card ' + (this.state.selectedPlan && this.state.selectedPlan.id === 1 ? 'selected' : '')}
                                                                            onClick={() => this.handlePlanSelect({ id: 1, name: '3 Days', price: 'Rp 3.000', duration: '3 Hari' })}
                                                                        >
                                                                            <div className="plan-badge">Regular</div>
                                                                            <div className="plan-duration">3 Hari</div>
                                                                            <div className="plan-price">Rp 3.000</div>
                                                                            <div className="plan-description">Akses penuh selama 3 hari</div>
                                                                            {this.state.selectedPlan && this.state.selectedPlan.id === 1 && (
                                                                                <div className="plan-check">
                                                                                    <i className="fa fa-check-circle"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                
                                                                        {/* Plan 2: Weekly }
                                                                        <div 
                                                                            className={'subscription-plan-card ' + (this.state.selectedPlan && this.state.selectedPlan.id === 2 ? 'selected' : '')}
                                                                            onClick={() => this.handlePlanSelect({ id: 2, name: 'Weekly', price: 'Rp 8.800', duration: '7 Hari' })}
                                                                        >
                                                                            <div className="plan-badge popular">Populer</div>
                                                                            <div className="plan-duration">7 Hari</div>
                                                                            <div className="plan-price">Rp 8.800</div>
                                                                            <div className="plan-description">Akses penuh selama 1 minggu</div>
                                                                            {this.state.selectedPlan && this.state.selectedPlan.id === 2 && (
                                                                                <div className="plan-check">
                                                                                    <i className="fa fa-check-circle"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                
                                                                        {/* Plan 3: Monthly }
                                                                        <div 
                                                                            className={'subscription-plan-card ' + (this.state.selectedPlan && this.state.selectedPlan.id === 3 ? 'selected' : '')}
                                                                            onClick={() => this.handlePlanSelect({ id: 3, name: 'Monthly', price: 'Rp 22.000', duration: '30 Hari' })}
                                                                        >
                                                                            <div className="plan-badge best-value">Hemat</div>
                                                                            <div className="plan-duration">30 Hari</div>
                                                                            <div className="plan-price">Rp 22.000</div>
                                                                            <div className="plan-description">Akses penuh selama 1 bulan</div>
                                                                            {this.state.selectedPlan && this.state.selectedPlan.id === 3 && (
                                                                                <div className="plan-check">
                                                                                    <i className="fa fa-check-circle"></i>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        {*/}
                                                                    </div>
                
                                                                    {/* Action Buttons */}
                                                                    <div className="subscription-actions">
                                                                        <button 
                                                                            className={'telkomsel-payment-btn ' + (!this.state.selectedPlan ? 'disabled' : '')}
                                                                            onClick={this.handleTelkomselPayment}
                                                                            disabled={!this.state.selectedPlan}
                                                                        >
                                                                            <span className="btn-text">Pembayaran Telkomsel</span>
                                                                        </button>
                                                                        <button 
                                                                            className={'lanjut-btn ' + (!this.state.selectedPlan ? 'disabled' : '')}
                                                                            onClick={this.handleLanjutClick}
                                                                            disabled={!this.state.selectedPlan}
                                                                        >
                                                                            <span className="btn-text">Lanjut</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )}
                {
                    config.domain =='no' &&
                    <button className="whatsapp-button" onClick={(e) => this.onClickWhatsappIcon()}>
                        <img src={require('../../medias/whatsapp.png')} />
                    </button>
                }
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        addFavoriteVideo,
        showMessage,
        setHeaderTitle,
        getDetails,
        addLikesChannels,
        addLikesVideos,
        getInterests,
        addVideoHistory,
        addChannelHistory
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);


// WEBPACK FOOTER //
// ./src/components/Category/Category.js